// extracted by mini-css-extract-plugin
export default {"slideUp":"StayTypesSelect_slideUp__7MuxQ","slideDown":"StayTypesSelect_slideDown__7ey52"};